import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { INPUT_REGEX } from 'src/utilities/regexPatterns';

interface ReportNameControlProps {
  name: string;
  id: string;
}

export const ReportNameControl: React.FC<ReportNameControlProps> = ({
  name,
  id,
}) => {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      placeholder="e.g. January-2026-Report"
      control={control}
      error={errors[name]}
      label="Report Name *"
      inputSize="medium"
      blockWidth
      maxLength={100}
      rules={{
        required: 'Report Name is required',
        pattern: {
          value: INPUT_REGEX,
          message: 'Report Name is invalid',
        },
        validate: {
          isEmpty: (value: string): boolean | string =>
            value.trim() !== '' || 'Report Name must be filled out',
        },
        maxLength: {
          value: 100,
          message: 'Report Name cannot exceed 100 characters',
        },
      }}
    />
  );
};
